import {
  REDUCER_NAMES_FETCH_STATUSES_PUBLIC_FORMS,
} from '../../../../constants'
import getFetchStatusSelectors from '../HOF/fetchStatusSelectors'

export default getFetchStatusSelectors()(
  REDUCER_NAMES_FETCH_STATUSES_PUBLIC_FORMS,
)
